import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';

import TaskProfileDialog from '../TaskProfileDialog/index';
import { showDialog, hideDialog } from '../../../../redux/actions/dialogs';
import { hasPermission } from '../../../../utils/authenticated';
import Dashboard from '../../../Dashboard/index';
import {
  fetchItemTypesRoutine,
  fetchTaskProfilesRoutine,
  removeTaskProfilePromise,
  removeTaskProfileRoutine
} from '../../../../redux/routines';

import { isDialogVisibleSelector } from '../../../../redux/selectors';
import { TASK_PROFILE_DIALOG } from '../../../../redux/constants/dialogs';
import TaskProfilesGrid from '../TaskProfilesGrid/index';
import { toJS } from '../../../../utils/helper';

class TaskProfilesView extends Component {

  componentWillMount() {
    this.props.fetchItemTypes();

    this.setState({
      editable: hasPermission(['Administrator']),
    });
  }

  render() {
    const { isDialogVisible, taskProfiles, fetchTaskProfiles, removeTaskProfile, itemTypes, showDialog } = this.props;
    return (
      <Dashboard title="Task Profiles">

        <TaskProfilesGrid
          data={taskProfiles}
          fetch={fetchTaskProfiles}
          itemTypes={itemTypes}
          showDialog={showDialog}
          onRemove={removeTaskProfile}
        />

        {isDialogVisible(TASK_PROFILE_DIALOG) ? <TaskProfileDialog/> : null}
      </Dashboard>
    );
  }
}

TaskProfilesView.propTypes = {
  fetchItemTypes: PropTypes.func.isRequired,
  itemTypes: PropTypes.object,
  fetchTaskProfiles: PropTypes.func.isRequired,
  taskProfiles: PropTypes.object,
  removeTaskProfile: PropTypes.func.isRequired,

  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    taskProfiles: toJS(state.getIn(['taskprofiles', 'taskProfiles'])),
    itemTypes: toJS(state.getIn(['itemtypes', 'itemTypes'])),
    isDialogVisible: isDialogVisibleSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      fetchTaskProfiles: fetchTaskProfilesRoutine.trigger,
      fetchItemTypes: fetchItemTypesRoutine.trigger,
      removeTaskProfile: removeTaskProfileRoutine.trigger,
      showDialog,
      hideDialog,
    }, dispatch),
    ...bindPromiseCreators({
      removeTaskProfile: removeTaskProfilePromise,
    }, dispatch),
  };
}

//removeTaskProfilePromise

export default connect(mapStateToProps, mapDispatchToProps)(TaskProfilesView);



// WEBPACK FOOTER //
// ./src/components/Admin/TaskProfiles/TaskProfilesView/index.js